import { TimeTrackingReportGroupBy } from "@src/__generated__/graphql";
import { observer } from "mobx-react-lite";
import type { TTimeTrackingReport } from "../../models";
import { useStore } from "../../Store";

interface GroupByProps {
  type: TimeTrackingReportGroupBy.Date | TimeTrackingReportGroupBy.Brand;
  groupBy: TTimeTrackingReport["groupBy"];
}

const GroupBy = ({ type, groupBy }: GroupByProps) => {
  const store = useStore();

  if (
    type === TimeTrackingReportGroupBy.Brand &&
    ![TimeTrackingReportGroupBy.Date, TimeTrackingReportGroupBy.Brand].includes(
      // NOTE: This only renders for grouped table
      store.groupBy as TimeTrackingReportGroupBy,
    )
  ) {
    return null;
  }

  return <div className="font-semibold">{groupBy}</div>;
};

export default observer(GroupBy);
